import ErrorHandler from "./ErrorHandler"
import { api } from "services/api"

class ApiPurchasePlans extends ErrorHandler {
  async getAll(params?: string) {
    try {
      const axiosResponse = await api.get(`/purchasePlan/${params}`)

      return {
        purchasePlans: axiosResponse.data,
        status: axiosResponse.status
      }
    } catch (e) {
      return {
        purchasePlans: [],
        status: this.errorHandler(e)
      }
    }
  }

  async create(purchasePlan: App.PurchasePlanPayload) {
    return api.post("/purchasePlan", purchasePlan)
  }

  async update(purchasePlan: App.PurchasePlanPayload, _id: string) {
    return api.put(`/purchasePlan/${_id}`, purchasePlan)
  }

  async updateIsPublished(_id: string) {
    return api.put(`/purchasePlan/published/${_id}`)
  }

  async delete(_id: string) {
    return api.delete(`/purchasePlan/${_id}`)
  }

  async listPurchasePlanWithProduct(product: string) {
    const axiosResponse = await api.get(`/purchasePlan/${product}`)

    return {
      purchasePlans: axiosResponse.data,
      status: axiosResponse.status
    }
  }

  async getPurchasePlans(productPrefixUrl?: string) {
    const params = { productPrefixUrl: productPrefixUrl || undefined }

    const { data } = await api.get<{ purchasePlans: App.IPurchasePlan[] }>(`/purchasePlan`, { params })

    return data?.purchasePlans
  }

  async calculatePriceBySimulatedConsumption(eventTypeIds: string[], productId: string) {
    const consumptionSimulation = 1

    const { data } = await api.post<{ data: App.ISimulatedConsumption }>("/purchasePlan/pricing/simulation", {
      eventTypes: eventTypeIds,
      consumptionSimulation,
      productId
    })

    return data.data
  }

  async getPurchasePlanById(id: string) {
    const { data } = await api.get(`/purchasePlan/info/${id}`)

    return data.purchasePlan
  }
}

export default ApiPurchasePlans
